<template>
    <div v-loading="loading">
        <div class="operation-box">
            <div>
                <el-button @click="clickReturnBtn" v-show="mviewPart != 'list'" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
                &nbsp;
            </div>

            <div>
                <el-button type="primary" @click="clickAddBtn" v-show="mviewPart == 'list'" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
            </div>
        </div>
        <div v-if="mviewPart == 'list'">
            <el-table :data="productCouPonsList" style="width: 100%">
                <el-table-column :label="'產品id'" >
                    <template #default="scope">
                        <span>{{scope.row.ProductID}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="PromoProductID" :label="'綁定產品id'" />
                <el-table-column :label="'有效期'" >
                    <template #default="scope">
                        <span>{{scope.row.PromoStartDate}}-{{scope.row.PromoEndDate}}</span>
                    </template>
                </el-table-column>

                <el-table-column :label="i18n.tkey('lang_operate')" >
                    <template #default="scope">

                      <el-button type="primary" size="small" @click="clickEditBtn(scope.row)" tkey="查看">{{i18n.tkey("lang_check")}}</el-button>

                        <div class="next-line-div">

                        </div>

                        <el-button type="danger" size="small" @click="clickDelBtn(scope.row)">
                            <font-awesome-icon icon="fa-solid fa-trash" />
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="mviewPart == 'add'">
            <insertOrEditMaterialCoupons v-if="myUtil.isNotEmpty(productObj)"  :editObj="productObj"  @clickAdd="saveCouponsCallback" />
        </div>
      <div v-if="mviewPart == 'edit'">
        <lookMaterialCoupons v-if="myUtil.isNotEmpty(editObj)"  :productObj="productObj"  :editObj="editObj"  />
      </div>
<!--          <el-dialog
              v-show="mviewPart == 'edit'"
              v-model="openProductCouPons"
              :title="''"
              :width="myUtil.isMobile() ? '90%' : '600px'"
              align-center
              destroy-on-close
              :close-on-click-modal="false"
              :close-on-press-escape="false"
          >

          </el-dialog>-->
      </div>
</template>

<script setup>
    import {inject, ref, onBeforeMount, onMounted, watch, toRef} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faTrash, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import InsertOrEditMaterialCoupons from "@/components/shopopee/material/insertOrEditMaterialCoupons.vue";
    import LookMaterialCoupons from "@/components/shopopee/material/lookMaterialCoupons.vue";

    library.add(faTrash, faPenToSquare)

    const props = defineProps(['modelValue','productObj'])
    const emits = defineEmits(['update:modelValue','changeCouponsList'])

    const i18n = inject("i18n")

    const loading = ref(false)
    const productCouPonsList = ref([])

    const mviewPart = ref("list")
    const editObj = ref(null)
    const openProductCouPons = ref(false)

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})

    watch(() => props.modelValue, (newValue, oldValue) => {
        productCouPonsList.value = newValue
    })

    function clickAddBtn() {
        editObj.value = null
        mviewPart.value = "add"
    }

    function clickEditBtn(obj) {
      mviewPart.value = "edit"
        editObj.value = obj
        openProductCouPons.value = true
    }


    function clickReturnBtn(){
      mviewPart.value = "list"
       // editObj.value = null
    }

    function clickDelBtn(obj){
        if (myUtil.isNotEmpty(obj.ID)){
          loading.value = true

          const request = eshopopeeApi.delCouponsMaterial
          const params =obj

          request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
              console.log(res.detail)
              clickReturnBtn()

              emits("changeCouponsList")
            }
          })
        }else{

        }

       // emits("update:modelValue", wholesaleSettingList.value)
    }

    function saveCouponsCallback(obj){//添加
      loading.value = true
      console.log(obj)
      const request = eshopopeeApi.updateProductCouPons
      const params =obj

      request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){
          console.log(res.detail)
          clickReturnBtn()

          emits("changeCouponsList")
        }
      })


    }




    onBeforeMount(() => {
        shopCompany.value = getShopCompanyObj()

    })
</script>

<style scoped>

    .operation-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    @media screen and (min-width: 768px) {
        .next-line-div {
            display: inline-block;
            width: 10px;
        }
    }

    @media screen and (max-width: 768px) {
        .next-line-div {
            height: 10px;
        }
    }
</style>